import { DateRangeSchema } from 'common/hooks/customSearchParams';
import React from 'react';

interface Props {
  disabled?: boolean;
  active: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
  label: string | React.ReactNode;
  value: DateRangeSchema | string;
}

export const Tab: React.FC<Props> = (props) => {
  const { disabled, label, active, onChange, value } = props;

  let extraClasses = '';
  if (disabled) {
    extraClasses = 'bg-gray-200 pointer-events-none text-gray-500';
  } else if (active) {
    extraClasses = 'bg-gray-100 text-gray-900 cursor-pointer';
  } else {
    extraClasses = 'bg-white text-gray-500 hover:bg-gray-100 cursor-pointer';
  }
  const className = `px-3 flex items-center py-2 text-xs border border-r-0 border-gray-300 font-medium transition-colors last:rounded-r last:border first:rounded-l ${extraClasses}`;

  return (
    <div onClick={() => onChange(value)} className={className}>
      <h5>{label}</h5>
    </div>
  );
};
